export type WalletMetric = {
  label: string;
  value: string;
  hint?: string;
  note?: string;
};

export function MetricsGrid({ metrics }: { metrics: WalletMetric[] }) {
  return (
    <div className="mb-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {metrics.map((m) => (
        <div
          key={m.label}
          className="rounded-xl border border-[var(--dash-line)] bg-white px-4 py-4 text-left"
        >
          <p className="text-xs text-[var(--dash-muted)]">{m.label}</p>
          <p className="mt-1.5 text-lg font-bold text-[var(--dash-ink)]">{m.value}</p>
          {m.note ? (
            <p className="mt-1 text-[11px] text-[var(--dash-muted)]">{m.note}</p>
          ) : null}
          {m.hint ? (
            <p className="mt-1 text-[11px] text-[var(--dash-muted)]">{m.hint}</p>
          ) : null}
        </div>
      ))}
    </div>
  );
}
